import React, { useState, useEffect } from 'react';
import './youHaveChosen.scss';
import classNames from 'classnames';
export default function YouHaveChosen(props: any) {

    const [trades, setTrades] = useState<any[]>([]);
    const [filteredTrades, setFilteredTrades] = useState<any[]>([]);
    const [showTrades, setShowTrades] = useState<boolean>(false);

    var tradeClassNames = classNames(
        {
            'customer-selection': true,
            'trade-selected': true,
            'selected': showTrades,
            'please-select': props.profession === "Please select"
        }
    );

    useEffect(() => {
        setTrades(props.trades);
        setFilteredTrades(props.trades);
    }, [])

    let statusDisplayText = "";

    if (props.companyStatus === "limited") {
        statusDisplayText = "Limited Company";
    }

    if (props.companyStatus === "partner") {
        statusDisplayText = "Partnership";
    }

    if (props.companyStatus === "trader") {
        statusDisplayText = "Sole Trader";
    }

    const searchTrades = (e: React.ChangeEvent<HTMLInputElement>) => {
        let searchTerm = e.target.value;

        if (searchTerm !== "") {
            document.getElementById('search-results')?.scroll({ top: 0, behavior: 'smooth' });
            setFilteredTrades(trades.filter(x => x.description.toLowerCase().includes(searchTerm.toLowerCase())));
        } else {
            setFilteredTrades(trades);
        }
    }

    const showSelection = () => {
        setShowTrades(!showTrades);

        if (!showTrades === false) {
            setFilteredTrades(trades);
        }
    }

    const updateTrade = (index: number) => {
            let selectedTrade = filteredTrades[index];
            props.updateTrade(selectedTrade);
            showSelection();
    }

    return (
        <div className="you-have-chosen">
            <div className="you-have-chosen-header">You have chosen:</div>
            <span className="you-have-chosen-content"><span className={tradeClassNames} onClick={() => showSelection()}>{props.profession}</span>
                {showTrades &&
                    <div className="update-container">
                        <input type="text" className="trade-update-search" placeholder="Search" onChange={(e) => searchTrades(e)} />
                        <div className="update-trade-dropdown">
                            {filteredTrades.map((trade, index) => (
                                <div className="dropdown-row" key={"trade_" + index} onClick={() => updateTrade(index)}>{trade.description}</div>
                            ))}
                        </div>
                    </div>
                }
                &nbsp;profession 
                {statusDisplayText !== "" && <>
                    &nbsp;and <span className="customer-selection">{statusDisplayText}</span> status.
                </>
                }
            </span>
        </div>
    )

}